import * as types from "../constants";

const initialState = {
	siteMap: [],
	siteMapData: [],
	isReq: false,
};

const getHomeSiteMapData = (state = initialState, action) =>
{
	switch (action.type)
	{
		case types.GET_HOME_SITE_NAV_BEGIN:
			return {...state, isReq: true};
		case types.GET_HOME_SITE_NAV:
			return {...state, isReq: false, siteMap: [...action.siteMap]};
		case types.GET_HOME_SITE_NAV_ITEM:
			let newSiteMapData = JSON.parse(JSON.stringify(state.siteMap));
			newSiteMapData[action.index] = {...action.menu};
			return {...state, siteMapData: newSiteMapData};
		case types.RESET_HOME:
			return {siteMap: [], siteMapData: []}
		default:
			return state;
	}
};

export default getHomeSiteMapData;